import { configFactory, getOrThrow } from '@digitsole/blackburn-configuration';

export const saasConfig = configFactory({
  default: getOrThrow('saas.api.url', { type: 'string', prefix: 'blackburn' }) as string,
  site: getOrThrow('saas.site', { type: 'string', prefix: 'blackburn' }) as string
});
